<div
  #container
  (tunResize)="onResizeContainer($event)"
  class="wrapper"
  >
  <div class="title">{{ (musicChannelGroup != null) ? musicChannelGroup.name : ''}}</div>
  <hr class="horizontalLine"/>
  @if (musicChannelGroup != null) {
    <div class="musicChannelContainer {{ gridClassName }}">
      @for (musicChannel of musicChannelGroup.musicChannels; track musicChannel) {
        <tun-music-channel-view
          class="musicChannel"
          [imageHolder]="musicChannel"
          (showDetails)="onShowDetails($event)"
          [playButtonShowStragegy]="playButtonShowStragegy">
        </tun-music-channel-view>
      }
    </div>
  }
</div>
